import { IApplicationState } from '../../types/redux';

export const selectCheckEstimationExists = (state: IApplicationState) => state.checkEstimationExists;
